import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IDecrementalTableReport,
  IIncrementalTableReport,
} from "../../Interfaces/deltaHedgeSettings";

interface ISlice {
  addEditIncrementalFormValues: IIncrementalTableReport;
  incrementalTableRefetchFlag: boolean;
  incrementalEditFlag: boolean;
  addEditDecrementalFormValues: IDecrementalTableReport;
  decrementalTableRefetchFlag: boolean;
  decrementalEditFlag: boolean;
  addEditModalFlag: boolean;
}

const initialState: ISlice = {
  addEditIncrementalFormValues: {} as IIncrementalTableReport,
  incrementalTableRefetchFlag: false,
  incrementalEditFlag: false,
  addEditDecrementalFormValues: {} as IDecrementalTableReport,
  decrementalTableRefetchFlag: false,
  decrementalEditFlag: false,
  addEditModalFlag: false,
};

const DeltaHedgeSettingsSlice = createSlice({
  name: "deltaHedgeSettings",
  initialState,
  reducers: {
    addEditIncrementalFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.addEditIncrementalFormValues = {
        ...store.addEditIncrementalFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setAddEditIncrementalFormValues: (
      store,
      action: PayloadAction<IIncrementalTableReport>
    ) => {
      store.addEditIncrementalFormValues = action.payload;
    },
    setIncrementalTableFlag: (store, action: PayloadAction<boolean>) => {
      store.incrementalTableRefetchFlag = action.payload;
    },
    setIncrementalEditFlag: (store, action: PayloadAction<boolean>) => {
      store.incrementalEditFlag = action.payload;
    },
    addEditDecrementalFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.addEditDecrementalFormValues = {
        ...store.addEditDecrementalFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setAddEditDecrementalFormValues: (
      store,
      action: PayloadAction<IDecrementalTableReport>
    ) => {
      store.addEditDecrementalFormValues = action.payload;
    },
    setDecrementalTableFlag: (store, action: PayloadAction<boolean>) => {
      store.decrementalTableRefetchFlag = action.payload;
    },
    setDecrementalEditFlag: (store, action: PayloadAction<boolean>) => {
      store.decrementalEditFlag = action.payload;
    },
    setHeltaHedgeSettingsAddEditModalFlag: (store, action: PayloadAction<boolean>) => {
      store.addEditModalFlag = action.payload;
    },
  },
});

export const {
  setAddEditIncrementalFormValues,
  setIncrementalTableFlag,
  addEditIncrementalFormValuesChangeHandler,
  addEditDecrementalFormValuesChangeHandler,
  setAddEditDecrementalFormValues,
  setDecrementalTableFlag,
  setIncrementalEditFlag,
  setDecrementalEditFlag,
  setHeltaHedgeSettingsAddEditModalFlag,
} = DeltaHedgeSettingsSlice.actions;
export default DeltaHedgeSettingsSlice.reducer;
